<template>
  <div id="busnessRankMgmt">
    <el-menu class="el-menu-demo" mode="horizontal" :default-active="activeIndex" @select="handleSelect">
      <el-menu-item index="1">卖家前1000商品数量排行</el-menu-item>
      <el-menu-item index="2">品牌商品数量排行</el-menu-item>
      <el-menu-item index="3">品牌销售金额排行</el-menu-item>
    </el-menu>

    <transition name="rank" mode="out-in">
      <keep-alive>
        <components :is="currentComponent"></components>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import businessTable from "@v/busnessRankMgmt/components/businessTable.vue"
  import brandTable from "@v/busnessRankMgmt/components/brandTable.vue"
  import salesAmountTable from "@v/busnessRankMgmt/components/salesAmountTable.vue"
  export default {
    data() {
      return {
        currentComponent: businessTable,
        activeIndex: "1",
        tableData: [],
        componentList: [
          businessTable,
          brandTable,
          salesAmountTable
        ]
      }
    },
    components: {
      businessTable,
      brandTable,
      salesAmountTable
    },
    methods: {
      handleSelect: function(key, keyPath) {
        this.activeIndex = key;
        this.currentComponent = this.componentList[key-1];
      }
    }
  }
</script>

<style lang="scss" scoped>
.rank-enter-active, .rank-leave-active {
  transition: opacity .3s ease;
}
.rank-enter, .rank-leave-to {
  opacity: 0;
}
</style>
